// src/features/Gnn/postNewsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  iframeMessage: {},
};

const webviewSlice = createSlice({
  name: 'webview',
  initialState: initialState,
  reducers: {
    setIframeMessage: (state, action) => {
      state.iframeMessage = action.payload;
    },
    cleariframeMessage: (state) => {
      state.iframeMessage = {};
    },
  },
});

export const { setIframeMessage,cleariframeMessage } = webviewSlice.actions;
export const selectIframeMessage = (state) => state.webview.iframeMessage;

export default webviewSlice.reducer;
